import { Amplify } from 'aws-amplify'

interface CognitoConfig {
  userPoolId: string
  userPoolClientId: string
  region: string
  identityPoolId?: string
  loginWith: {
    email: boolean
  }
  signUpVerificationMethod: 'code'
  userAttributes: {
    email: {
      required: boolean
    }
  }
}

type AmplifyConfig = Parameters<typeof Amplify.configure>[0]
type AmplifyCognitoConfig = AmplifyConfig extends { Auth?: { Cognito?: infer T } } ? T : never

const deriveRegionFromPoolId = (poolId?: string) => {
  if (!poolId) return undefined
  const prefix = poolId.split('_')[0]
  return prefix || undefined
}

export const configureAuth = () => {
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID
  const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID
  const identityPoolId = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID
  const region = import.meta.env.VITE_COGNITO_REGION || "eu-west-1"

  if (!userPoolId || !userPoolClientId || !region) {
    console.error('[Auth] Missing Cognito configuration: ensure pool id, client id, and region are set.')
    return
  }

  const cognitoConfig: CognitoConfig = {
    userPoolId,
    userPoolClientId,
    region,
    identityPoolId: identityPoolId || undefined,
    loginWith: {
      email: true,
    },
    signUpVerificationMethod: 'code',
    userAttributes: {
      email: {
        required: true,
      },
    },
  }

  const amplifyCognitoConfig = cognitoConfig as unknown as AmplifyCognitoConfig

  Amplify.configure({
    Auth: {
      Cognito: amplifyCognitoConfig,
    }
  })
}

